// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../dist/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_container__qVLsn {
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  height: fit-content;
  padding: 0.5em 0;
}
.styles_container__qVLsn input {
  background-color: transparent;
  width: 100%;
  max-width: 100% !important;
  border: none;
  border-radius: 8px;
  border: 1px solid #eeeeee;
  background-color: transparent;
  width: 100%;
  border: none;
  padding: 0 5px;
  background: transparent !important;
  max-width: 100% !important;
}
.styles_container__qVLsn input:focus-visible {
  outline: 0;
}
.styles_container__qVLsn input::placeholder {
  color: #bababa;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  font-family: IranSans_Light;
}

.styles_inputTitle__SfuMo {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  margin-bottom: 8px;
}

.styles_inputError__jyXfY {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: #ff9315 !important;
  margin-top: 8px;
}

.styles_inputErrorProfile__-N0t2 {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #d8000d !important;
  margin-bottom: 8px;
}

.styles_inputStyle__fKMp3 {
  width: 100%;
}

.styles_wrapper__tUcd2 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px;
  border-radius: 8px;
  border: 1px solid #eeeeee;
  width: 353px;
  height: 44px;
}

.styles_prefix__9oj6\\+,
.styles_affix__pDc43 {
  display: flex;
  justify-content: center;
  align-items: center;
}

.styles_yellowBorder__bQFqe {
  border-bottom: 1px solid #ff9315 !important;
}

.styles_redBorder__2zHv0 {
  border: 1px solid #d8000d;
}

.styles_lds_ring__7i7bj {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  margin-bottom: 10px;
}

.styles_lds_ring__7i7bj div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 14px;
  height: 14px;
  margin: 8px;
  border: 1px solid #d8000d;
  border-radius: 50%;
  animation: styles_lds_ring__7i7bj 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: #d8000d transparent transparent transparent;
}

.styles_lds_ring__7i7bj div:nth-child(1) {
  animation-delay: -0.45s;
}

.styles_lds_ring__7i7bj div:nth-child(2) {
  animation-delay: -0.3s;
}

.styles_lds_ring__7i7bj div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes styles_lds_ring__7i7bj {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.styles_extraInfoStyle__MhG5w {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  /* identical to box height, or 167% */
  color: #9d9d9d;
}

@media screen and (max-width: 800px) {
  .styles_wrapper__tUcd2 {
    width: 100%;
  }
  .styles_inputStyle__fKMp3 {
    width: 100%;
  }
  .styles_container__qVLsn input::placeholder {
    font-size: 14px;
  }
}`, "",{"version":3,"sources":["webpack://./../src/renderer/components/AppFormInput/styles.module.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,aAAA;EACA,2BAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;AACF;AACE;EACE,6BAAA;EACA,WAAA;EACA,0BAAA;EACA,YAAA;EAEA,kBAAA;EACA,yBAAA;EAKA,6BAAA;EACA,WAAA;EACA,YAAA;EACA,cAAA;EAEA,kCAAA;EACA,0BAAA;AALJ;AAQE;EACE,UAAA;AANJ;AASE;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,2BAAA;AAPJ;;AAYA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAEA,kBAAA;AAVF;;AAaA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;AAVF;;AAaA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,kBAAA;AAVF;;AAaA;EAEE,WAAA;AAXF;;AAeA;EAEE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,YAAA;EAEA,kBAAA;EACA,yBAAA;EACA,YAAA;EACA,YAAA;AAdF;;AAiBA;;EAEE,aAAA;EACA,uBAAA;EACA,mBAAA;AAdF;;AAiBA;EACE,2CAAA;AAdF;;AAiBA;EACE,yBAAA;AAdF;;AAmBA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAhBF;;AAmBA;EACE,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,4EAAA;EACA,yDAAA;AAhBF;;AAmBA;EACE,uBAAA;AAhBF;;AAmBA;EACE,sBAAA;AAhBF;;AAmBA;EACE,uBAAA;AAhBF;;AAmBA;EACE;IACE,uBAAA;EAhBF;EAmBA;IACE,yBAAA;EAjBF;AACF;AAoBA;EACE,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,qCAAA;EAEA,cAAA;AAnBF;;AAuBA;EACE;IACE,WAAA;EApBF;EAwBA;IACE,WAAA;EAtBF;EA6BE;IACE,eAAA;EA3BJ;AACF","sourcesContent":[".container {\n  box-sizing: border-box;\n  display: flex;\n  justify-content: flex-start;\n  flex-direction: column;\n  align-items: flex-start;\n  height: fit-content;\n  padding: 0.5em 0;\n\n  input {\n    background-color: transparent;\n    width: 100%;\n    max-width: 100% !important;\n    border: none;\n    // background-color: #fafafa;\n    border-radius: 8px;\n    border: 1px solid #eeeeee;\n    // width: 353px;\n    // height: 44px;\n    // padding: 0 0.5em;\n\n    background-color: transparent;\n    width: 100%;\n    border: none;\n    padding: 0 5px;\n\n    background: transparent !important;\n    max-width: 100% !important;\n  }\n\n  input:focus-visible {\n    outline: 0;\n  }\n\n  input::placeholder {\n    color: #bababa;\n    font-style: normal;\n    font-weight: 400;\n    font-size: 14px;\n    font-family: IranSans_Light;\n    // color: #969696;\n  }\n}\n\n.inputTitle {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  // color: #707070;\n  margin-bottom: 8px;\n}\n\n.inputError {\n  font-style: normal;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n  color: #ff9315 !important;\n  margin-top: 8px;\n}\n\n.inputErrorProfile {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  color: #d8000d !important;\n  margin-bottom: 8px;\n}\n\n.inputStyle {\n  // width: 353px;\n  width: 100%;\n  // height: 44px;\n}\n\n.wrapper {\n  // width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 5px;\n  // background-color: #fafafa;\n  border-radius: 8px;\n  border: 1px solid #eeeeee;\n  width: 353px;\n  height: 44px;\n}\n\n.prefix,\n.affix {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.yellowBorder {\n  border-bottom: 1px solid #ff9315 !important;\n}\n\n.redBorder {\n  border: 1px solid #d8000d;\n}\n\n//------------------------loader style\n\n.lds_ring {\n  display: inline-block;\n  position: relative;\n  width: 20px;\n  height: 20px;\n  margin-bottom: 10px;\n}\n\n.lds_ring div {\n  box-sizing: border-box;\n  display: block;\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  margin: 8px;\n  border: 1px solid #d8000d;\n  border-radius: 50%;\n  animation: lds_ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n  border-color: #d8000d transparent transparent transparent;\n}\n\n.lds_ring div:nth-child(1) {\n  animation-delay: -0.45s;\n}\n\n.lds_ring div:nth-child(2) {\n  animation-delay: -0.3s;\n}\n\n.lds_ring div:nth-child(3) {\n  animation-delay: -0.15s;\n}\n\n@keyframes lds_ring {\n  0% {\n    transform: rotate(0deg);\n  }\n\n  100% {\n    transform: rotate(360deg);\n  }\n}\n\n.extraInfoStyle {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 20px;\n  /* identical to box height, or 167% */\n\n  color: #9d9d9d;\n}\n\n// @media screen and (max-width: 576px) {\n@media screen and (max-width: 800px) {\n  .wrapper {\n    width: 100%;\n    // max-width: 353px;\n  }\n\n  .inputStyle {\n    width: 100%;\n    // max-width: 353px;\n\n    // height: 44px;\n  }\n\n  .container {\n    input::placeholder {\n      font-size: 14px;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `styles_container__qVLsn`,
	"inputTitle": `styles_inputTitle__SfuMo`,
	"inputError": `styles_inputError__jyXfY`,
	"inputErrorProfile": `styles_inputErrorProfile__-N0t2`,
	"inputStyle": `styles_inputStyle__fKMp3`,
	"wrapper": `styles_wrapper__tUcd2`,
	"prefix": `styles_prefix__9oj6+`,
	"affix": `styles_affix__pDc43`,
	"yellowBorder": `styles_yellowBorder__bQFqe`,
	"redBorder": `styles_redBorder__2zHv0`,
	"lds_ring": `styles_lds_ring__7i7bj`,
	"extraInfoStyle": `styles_extraInfoStyle__MhG5w`
};
export default ___CSS_LOADER_EXPORT___;
